import { Component } from '@angular/core';
import { pessoaFisica } from '../../../pessoa-tipo';

@Component({
    selector: 'sgt-pessoa-tipo-badge-fisica',
    templateUrl: './pessoa-tipo-badge-fisica.component.html',
    styleUrls: ['./pessoa-tipo-badge-fisica.component.less']
})
export class PessoaTipoBadgeFisicaComponent {
    tipo = pessoaFisica;
}
